// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__31fTB","itemTitle":"ClientEmergencyInfo_itemTitle__2_829","itemText":"ClientEmergencyInfo_itemText__1Nvc1"};